import { render, staticRenderFns } from "./DiscountImportSpreadsheet.vue?vue&type=template&id=49f44068&scoped=true"
import script from "./DiscountImportSpreadsheet.vue?vue&type=script&lang=js"
export * from "./DiscountImportSpreadsheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f44068",
  null
  
)

export default component.exports